import React, {Component} from 'react';
import {Input, Card, Table, Popconfirm, message,Modal, Button, TreeSelect, Spin } from 'antd';
import {applicationName, uuid} from "../../utils";
import {jsonPost, post} from "../../actions";
import ViewModal from "./ViewModal";
const { SHOW_PARENT } = TreeSelect;

const tabList = [
    {
        key: 'column',
        tab: '栏目分类',
    },
    {
        key: 'keyword',
        tab: '关键字分类',
    },
];

class ColumnManage extends Component {

    state = {
        tabKey : "column"
    };

    contentList = {
        column : <ColumnTable />,
        keyword: <KeyWordTable />
    };

    onTabChange = (key, type) => {
        console.log(key, type);
        this.setState({ [type]: key });
    };

    render() {
        return (
            <Card
                style={{ margin:15 }}
                tabList={tabList}
                activeTabKey={this.state.tabKey}
                onTabChange={key => {
                    this.onTabChange(key, 'tabKey');
                }}
            >
                {this.contentList[this.state.tabKey]}
            </Card>
        );
    }
}

class ColumnTable extends Component{

    columns = [
        {
            title: '分类名称',
            dataIndex: 'columnName',
            key: 'columnName'
        },
        {
            title: '标签',
            dataIndex: 'columnNames',
            key: 'columnNames',
            render:(text, record) =>{
                if(record.columnNames && record.columnNames.length > 0){
                    return (<div style={{
                        overflow:"hidden",
                        textOverflow:"ellipsis",
                        whiteSpace:"nowrap",
                        display: "block"
                    }}>{
                        record.columnNames.map((item) =>{
                            return <span style={{marginLeft: 5}}>{item}</span>;
                        })
                    }</div>)
                }
            }
        },
        {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            align: 'center',
            render: (text, record) =>{
                return (<span>
                    <a onClick={() => this.editColumn(record)}>编辑</a>
                    <Popconfirm key={uuid()} placement="topLeft" title={"您确定要删除吗？"}
                                onConfirm={() => this.deleteById(record.id)} okText="是" cancelText="否">
                                <a style={{marginLeft: 15}}>删除</a>
                    </Popconfirm>
            </span>)
            }
        }
    ];

    state = {
        total : 0,
        dataSource : []
    };

    params = {
        type : 2,
        queryStr:"",
        start: 1,
        size: 10
    };

    defaultParams = {
        start: 1,
        size: 10
    };

    componentDidMount() {
        this.loadData(this.params)
    }

    loadData = (params) =>{
        let url = "/cm-sites-" + applicationName() + "/column/list";
        post(url,params,(res) =>{
            if(res.status === 200){
                this.setState({
                    total: res.data.count,
                    dataSource: res.data.data
                })
            }
        });
    };

    pageChange = (page, pageSize) => {
        this.updateTableData(page, pageSize);
    };

    onShowSizeChange = (current, size) => {
        this.updateTableData(current, size);
    };

    updateTableData = (start, size) =>{
        this.params = {
            ...this.params,
            start: start,
            size:size
        };
        this.loadData(this.params);
    };

    editColumn = (record) =>{
        this.refs.columnClassify.showModal(record,this.updateTableData);
    };

    deleteById = (id) =>{
        let url = '/cm-sites-pms/column/delete';
        post(url, {columnId: id},(res) =>{
            if(res){
                message.info("删除成功！");
                this.updateTableData(this.defaultParams.start, this.defaultParams.size)
            }else {
                message.error("删除失败！");
            }
        });
    };

    insertClassify = () =>{
        this.refs.columnClassify.showModal({id:0},this.updateTableData);
    };

    render() {
        return (
            <>
                <Button type="primary" onClick={() => this.insertClassify(0)} style={{marginBottom: 10}}>新增</Button>
                <ColumnClassifyModal ref={"columnClassify"}/>
                <Table dataSource={this.state.dataSource} columns={this.columns}
                       scroll={{y:document.body.clientHeight - 332}}
                       pagination={{
                           showQuickJumper: true,
                           current: this.params.start,
                           total: this.state.total,
                           onChange: this.pageChange,
                           style: {marginRight: '20px'},
                           showTotal: total => `共 ${total} 条数据`,
                           showSizeChanger: true,
                           pageSizeOptions: ['10', '20', '30', '40'],
                           onShowSizeChange: this.onShowSizeChange
                       }}/>
                </>
        )
    }
}

class ColumnClassifyModal extends Component {

    state = {
        id: 0,
        visible : false,
        columnName : "",// 分类栏目名称
        columnNames:[],//栏目名称
        columnKeys : []
    };

    // 这个属性是为了解决在选择栏目之后（栏目下有多个子栏目）state不能及时更新，导致已选标签只能更新最后一个子栏目的问题
    checkedColumnNamesCopy = [];
    checkedColumnKeysCopy = [];

    okCallBack = (start, size) =>{};

    showModal = (record, callback) => {
        this.checkedColumnNamesCopy = record.columnNames || [];
        this.checkedColumnKeysCopy = record.columnKeys || [];
        this.setState({
            id : record.id,
            visible : true,
            columnName : record.columnName,
            columnNames: this.checkedColumnNamesCopy,
            columnKeys : this.checkedColumnKeysCopy
        });
        this.okCallBack = callback;
    };

    submit = () => {
        let columnName = this.refs.classifyName.state.value;
        let id = this.state.id;
        this.checkColumnNameRepeat(id, columnName,() =>{
            let url = '/cm-sites-pms/column/saveColumn';
            let params = {
                id: id,
                columnName : columnName,
                columnNames: this.state.columnNames,
                columnKeys: this.state.columnKeys,
                type: 2
            };
            jsonPost(url,JSON.stringify(params), (res)=>{
                if(res.status === 200){
                    Modal.info({
                        title : '提示',
                        content : '分类信息已保存，文章数据正在同步中，请稍后查看！',
                        onOk : () =>{
                            this.setState({
                                visible : false
                            });
                            this.okCallBack(1,10);
                        }
                    });
                }
            })
        });
    };

    checkColumnNameRepeat = (id, columnName, callback) =>{
        if(id){
            callback();
        }else {
            let url = "/cm-sites-pms/column/checkColumnName";
            post(url, {"columnName": columnName},(flag)=>{
                if(flag){
                    message.warn("当前栏目名称已存在！");
                }else {
                    callback();
                }
            })
        }
    };

    closeModal = () => {
        this.setState({
            visible : false
        })
    };

    changeCheckedColumn = (checked,checkedColumn) =>{
        let newCheckedColumnKeysCopy = this.checkedColumnKeysCopy;
        let newCheckedColumnNamesCopy = this.checkedColumnNamesCopy;
        if(checked){
            // 判断当前的栏目是否已选择
            let haveChecked = false;
            this.checkedColumnKeysCopy.map(item =>{
                if(item === checkedColumn.key){
                    haveChecked = true;
                }
            });
            if(haveChecked){
               return;
            }
            newCheckedColumnKeysCopy.push(checkedColumn.key);
            newCheckedColumnNamesCopy.push(checkedColumn.value);
        }else {
            newCheckedColumnKeysCopy = this.checkedColumnKeysCopy.filter((item, index) =>{
                if(item === checkedColumn.key){
                    newCheckedColumnNamesCopy = this.checkedColumnNamesCopy.filter((it, i) =>{
                        return index !== i;
                    });
                    return false;
                }
                return true;
            });
        }
        this.checkedColumnKeysCopy = newCheckedColumnKeysCopy;
        this.checkedColumnNamesCopy = newCheckedColumnNamesCopy;
        this.setState({
            columnKeys : newCheckedColumnKeysCopy,
            columnNames : newCheckedColumnNamesCopy
        })
    };

    render() {
        return (<Modal
            title={"网站栏目分类"}
            visible={this.state.visible}
            onOk={this.submit}
            onCancel={this.closeModal}
            destroyOnClose={true}
            width={800}
        >
            <div>
                <span style={{marginRight: 10,fontSize: 16}}>分类名称</span>
                <Input placeholder={'请输入分类名称'} style={{width: 200}} maxLength={10} ref={"classifyName"} defaultValue={this.state.columnName} />
            </div>

            <div style={{marginTop: 20}}>
                <span style={{fontSize: 16}}>标签管理</span>

                <div style={{fontSize: 15, margin: '10px 0'}}>
                    <span style={{marginRight: "8px", color: "#40a9ff"}}>|</span>
                    <span>已选标签</span>
                    {this.state.columnNames.map(item =>{
                        return <Button type="primary" style={{margin: 5}}>{item}</Button>;
                    })}
                </div>

                <div style={{fontSize: 15, margin: '10px 0'}}>
                    <span style={{marginRight: 8, color: "#40a9ff"}}>|</span>
                    <span style={{marginRight: 5}}>可选标签</span>

                    <ColumnTree changeCheckedColumn={this.changeCheckedColumn.bind(this)} selectedColumnKeys={this.state.columnKeys}/>
                </div>
            </div>
        </Modal>)
    }

}

class ColumnTree extends React.Component {

    state = {
        treeData: [],
        selectedKeys:[],
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () =>{
        let url = '/cm-sites-pms/website/loadAllWebsiteColumn';
        post(url,{}, (res) =>{
            if(res.status === 200){
                this.setState({
                    treeData : res.data,
                    selectedKeys: this.props.selectedColumnKeys
                })
            }else {
                message.error(res.msg);
            }
        })
    };

    onChange = (value, label, extra) => {
        let currentNode = extra.triggerNode;
        this.setState({
            selectedKeys : value
        });
        this.updateCheckedColumn(extra.checked,currentNode);
    };

    updateCheckedColumn = (checked,currentNode) =>{
        let nodeProps = currentNode.props;
        if(nodeProps.children && nodeProps.children.length > 0){
            nodeProps.children.map(item =>{
                this.updateCheckedColumn(checked,item);
            });
        }else {
            this.props.changeCheckedColumn(checked,{key: nodeProps.value, value: nodeProps.title});
        }
    };

    render() {
        const tProps = {
            treeData : this.state.treeData,
            onChange: this.onChange,
            onSelect: this.onSelect,
            treeCheckable: true,
            showCheckedStrategy: SHOW_PARENT,
            placeholder: '请选择',
            value : this.state.selectedKeys,
            style: {width: '80%'},
            showSearch: true,
            treeNodeFilterProp : 'title',
           /* listHeight : 100*/
        };
        return <TreeSelect {...tProps} dropdownStyle={{maxHeight:500}} />;
    }
}

class KeyWordTable extends Component {

    columns = [
        {
            title: '分类名称',
            dataIndex: 'columnName',
            key: 'columnName'
        },
        {
            title: '文章数',
            dataIndex: 'articleNumber',
            key: 'articleNumber'
        },
        {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            align: 'center',
            render: (text, record) =>{
                return (<span>
                    <a onClick={() => this.editColumn(record)}>编辑</a>
                    <Popconfirm key={uuid()} placement="topLeft" title={"您确定要删除吗？"}
                                onConfirm={() => this.deleteById(record.id)} okText="是" cancelText="否">
                                <a style={{marginLeft: 15}}>删除</a>
                    </Popconfirm>
            </span>)
            }
        }
    ];

    state = {
        total : 0,
        dataSource : []
    };

    params = {
        type : 3,
        queryStr:"",
        start: 1,
        size: 10
    };

    defaultParams = {
        start: 1,
        size: 10
    };

    componentDidMount() {
        this.loadData(this.params)
    }

    loadData = (params) =>{
        let url = "/cm-sites-" + applicationName() + "/column/list";
        post(url,params,(res) =>{
            if(res.status === 200){
                this.setState({
                    total: res.data.count,
                    dataSource: res.data.data
                })
            }
        });
    };

    pageChange = (page, pageSize) => {
        this.updateTableData(page, pageSize);
    };

    onShowSizeChange = (current, size) => {
        this.updateTableData(current, size);
    };

    updateTableData = (start, size) =>{
        this.params = {
            ...this.params,
            start: start,
            size:size
        };
        this.loadData(this.params);
    };

    editColumn = (record) =>{
        this.refs.keyWordClassifyModal.showModal(record,this.updateTableData);
    };

    deleteById = (id) =>{
        let url = '/cm-sites-pms/column/delete';
        post(url, {columnId: id},(res) =>{
            if(res){
                message.info("删除成功！");
                this.updateTableData(this.defaultParams.start, this.defaultParams.size)
            }else {
                message.error("删除失败！");
            }
        });
    };

    insertClassify = () =>{
        this.refs.keyWordClassifyModal.showModal({id:0},this.updateTableData);
    };

    render() {
        return (
            <>
                <Button type="primary" onClick={() => this.insertClassify(0)} style={{marginBottom: 10}}>新增</Button>
                <KeyWordClassifyModal ref={"keyWordClassifyModal"}/>
                <Table dataSource={this.state.dataSource} columns={this.columns}
                       scroll={{y:document.body.clientHeight - 332}}
                       pagination={{
                           showQuickJumper: true,
                           current: this.params.start,
                           total: this.state.total,
                           onChange: this.pageChange,
                           style: {marginRight: '20px'},
                           showTotal: total => `共 ${total} 条数据`,
                           showSizeChanger: true,
                           pageSizeOptions: ['10', '20', '30', '40'],
                           onShowSizeChange: this.onShowSizeChange
                       }}/>
            </>
        )
    }
}

class KeyWordClassifyModal extends Component {

    state = {
        visible : false,
        keyword : "",
        columnName : "",
        dataSource : [],
        total : 0,
        spinLoading : false
    };

    params = {
        labels:"",
        start: 1,
        size: 10
    };

    columns = [
        {
            title: '文章标题',
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: '作者',
            dataIndex: 'source',
            key: 'source'
        },
        {
            title: '发布时间',
            dataIndex: 'updateDate',
            key: 'updateDate'
        },
        {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            align: 'center',
            render: (text, record) =>{
                return (<span>
                    <a onClick={() => this.viewArticle(record)}>查看</a>
                    <Popconfirm key={uuid()} placement="topLeft" title={"您确定要删除吗？"}
                                onConfirm={() => this.deleteArticleById(record.id)} okText="是" cancelText="否">
                                <a style={{marginLeft: 15}}>删除</a>
                    </Popconfirm>
            </span>)
            }
        }
    ];

    submit = () => {
        let columnName = this.state.columnName;
        let id = this.state.id;
        this.checkColumnNameRepeat(id,columnName, ()=>{
            this.setState({
                spinLoading : true
            });
            let url = '/cm-sites-pms/column/saveColumn';
            let params = {
                id: id,
                labels: (() =>{
                    let labels = [];
                    labels.push(this.state.keyword);
                    return labels;
                })(),
                columnName : this.state.columnName,
                articleNumber : this.state.total,
                type: 3
            };
            jsonPost(url,JSON.stringify(params), (res)=>{
                if(res.status === 200){
                    Modal.info({
                        title : '提示',
                        content : '分类信息已保存，文章数据正在同步中，请稍后查看！',
                        onOk : () =>{
                            this.setState({
                                visible : false,
                                spinLoading : false,
                                keyword : "",
                                columnName : "",
                                dataSource : [],
                                total : 0
                            });
                            this.okCallBack(1,10);
                        }
                    });
                }
            })
        });
    };

    checkColumnNameRepeat = (id,columnName, callback) =>{
        if(id){
            callback();
        }else {
            let url = "/cm-sites-pms/column/checkColumnName";
            post(url, {"columnName": columnName},(flag)=>{
                if(flag){
                    message.warn("当前栏目名称已存在！");
                }else {
                    callback();
                }
            })
        }
    };

    okCallBack = (start, size) =>{};

    showModal = (record, callback) => {
        if(record.id){
            this.params.labels = record.labels[0];
            this.loadData(this.params);
            this.setState({
                id : record.id,
                visible : true,
                keyword : record.labels[0],
                columnName : record.columnName
            });
        }else {
            this.setState({
                id : record.id,
                visible : true,
            });
        }
        this.okCallBack = callback;
    };

    closeModal = () =>{
        this.setState({
            visible : false,
            keyword : "",
            columnName : "",
            dataSource : [],
            total : 0
        });
    };

    viewArticle = (record) => {
        this.refs.viewModal.showModal(record);
    };

    deleteArticleById = () =>{

    };

    pageChange = (page, pageSize) => {
        this.updateTableData(page, pageSize);
    };

    onShowSizeChange = (current, size) => {
        this.updateTableData(current, size);
    };

    updateTableData = (start, size) =>{
        this.params = {
            ...this.params,
            start: start,
            size:size
        };
        this.loadData(this.params);
    };

    loadData = (params) =>{
        let url = "/cm-sites-" + applicationName() + "/dataManage/pageListByLabels";
        post(url,params,(res) =>{
            if(res.status === 200){
                this.setState({
                    total: res.data.count,
                    dataSource: res.data.data
                })
            }
        });
    };

    keywordOnChange = (e) =>{
        this.setState({
            keyword : e.target.value,
            columnName : e.target.value
        });
    };

    columnNameOnChange = (e) =>{
        this.setState({
            columnName : e.target.value
        });
    };

    render() {
        return (<Modal
            title={"关键词分类"}
            visible={this.state.visible}
            onOk={this.submit}
            onCancel={this.closeModal}
            destroyOnClose={true}
            width={800}
        ><Spin spinning={this.state.spinLoading}>
            <div style={{marginBottom: 10}}>
                <span style={{marginRight: 26,fontSize: 16}}>关键词</span>
                <Input placeholder={'请输入关键词名称'} style={{width: 200}} maxLength={10} ref={"keyword"} value={this.state.keyword} onChange={this.keywordOnChange}/>
            </div>
            <div style={{marginBottom: 10}}>
                <span style={{marginRight: 10,fontSize: 16}}>分类名称</span>
                <Input placeholder={'请输入分类名称'} style={{width: 200}} maxLength={10} ref={"classifyName"} value={this.state.columnName} onChange={this.columnNameOnChange}/>
            </div>
            <ViewModal ref={'viewModal'}/>
            <div>
                <div style={{marginBottom:10}}><span style={{fontSize: 16}}>文章列表</span></div>
                <Table dataSource={this.state.dataSource} columns={this.columns}
                       scroll={{y:300}}
                       pagination={{
                           showQuickJumper: true,
                           current: this.params.start,
                           total: this.state.total,
                           onChange: this.pageChange,
                           style: {marginRight: '20px'},
                           showTotal: total => `共 ${total} 条数据`,
                           showSizeChanger: true,
                           pageSizeOptions: ['10', '20', '30', '40'],
                           onShowSizeChange: this.onShowSizeChange
                       }}/>
            </div>
        </Spin></Modal>)
    }

}

export default ColumnManage;